const DefaultPageSizeList = [10, 20, 30, 40, 50, 100, 200, 300, 400, 500];
const DefaultPageInfo = {
  page: 1,
  pageSize: 10
};

export { DefaultPageInfo, DefaultPageSizeList };
